import React from 'react';
import AdBanner from '../AdBanner/AdBanner';
import AffiliateBanner from '../AdBanner/AffiliateBanner';
import './Sidebar.css';

/**
 * Componente Sidebar para mostrar anúncios e banners de afiliados
 * na lateral da aplicação em dispositivos desktop
 */
const Sidebar = () => {
  // Exemplos de banners de afiliados para investimentos
  const affiliateBanners = [
    {
      id: 1,
      title: "Invista com segurança",
      description: "Rendimentos acima de 120% do CDI em investimentos seguros",
      link: "https://example.com/affiliate/investment",
      buttonText: "Investir agora",
      type: "investment"
    },
    {
      id: 2,
      title: "Curso de Investimentos",
      description: "Aprenda a investir do zero e construa sua independência financeira",
      link: "https://example.com/affiliate/course",
      buttonText: "Conhecer curso",
      type: "education",
      theme: "primary"
    }
  ];

  return (
    <aside className="sidebar">
      {/* Anúncio AdSense na parte superior da sidebar */}
      <div className="sidebar-section">
        <AdBanner 
          slot="3456789012" 
          format="rectangle"
          responsive={false}
          position="sidebar"
        />
      </div>
      
      {/* Banners de afiliados */}
      <div className="sidebar-section">
        <h3 className="sidebar-title">Recomendações</h3>
        {affiliateBanners.map(banner => (
          <AffiliateBanner 
            key={banner.id}
            title={banner.title}
            description={banner.description}
            link={banner.link}
            buttonText={banner.buttonText}
            type={banner.type}
            position="sidebar"
            customTheme={banner.theme}
          />
        ))}
      </div>
      
      {/* Anúncio AdSense na parte inferior da sidebar */}
      <div className="sidebar-section">
        <AdBanner 
          slot="6789012345" 
          format="rectangle"
          responsive={false}
          position="sidebar"
        />
      </div>
    </aside>
  );
};

export default Sidebar;
